import { ApiHttpService, ApiHttpServiceNewApi } from '../ApiHttpService';
import { BillingDataSerializer } from '../serializers/BillingDataSerializer';
import { BillingData, BILLING_DATA_TYPES } from '../../models/BillingData';
import { ParamsHelper } from '../../helpers/ParamsHelper';

const BILLING_DATA_PATH = 'Usuario/DatosFacturacion';

const NEWAPI_BILLING_DATA_PATH = '/BillingData';

class BillingDataController {
  static async all() {
    const authenticated = true;
    const response = await ApiHttpService.get(BILLING_DATA_PATH, {}, authenticated);
    const deSerializedData = (response.data || []).map(BillingDataSerializer.deSerialize);
    return deSerializedData.map(data => new BillingData(data));
  }

  static serializeBillingData(type, data) {
    switch (type) {
      case BILLING_DATA_TYPES.PERSONALID:
        return {
          DFWTipoDocumento: 1,
          DFWNombre: data.fullName,
          DFWCiRut: data.personalId,
          DFWDireccion: data.address,
          DFWDepartamento: data.department,
          DFWLocalidad: data.locality,
        };
      case BILLING_DATA_TYPES.RUT:
        return {
          DFWTipoDocumento: 2,
          DFWNombre: data.socialReason,
          DFWCiRut: data.rut,
          DFWDireccion: data.address,
          DFWDepartamento: data.department,
          DFWLocalidad: data.locality,
        };
      case BILLING_DATA_TYPES.OTHER:
        return {
          DFWTipoDocumento: 10,
          DFWNombre: data.fullName,
          DFWCiRut: data.personalId,
          DFWDireccion: data.address,
          DFWDepartamento: data.department,
          DFWLocalidad: data.locality,
        };
      default:
        return null;
    }
  }

  static serializeBillingDataNewApi(type, data) {
    let dataNew = {};
    switch (type) {
      case BILLING_DATA_TYPES.PERSONALID:
        dataNew = {
          DocumentType: 1,
          Name: data.fullName,
          RUT: data.personalId,
          Address: data.address,
          Department: data.department,
          Locality: data.locality,
        };
        break;
      case BILLING_DATA_TYPES.RUT:
        dataNew = {
          DocumentType: 2,
          Name: data.socialReason,
          RUT: data.rut,
          Address: data.address,
          Department: data.department,
          Locality: data.locality,
        };
        break;
      case BILLING_DATA_TYPES.OTHER:
        dataNew = {
          DocumentType: 10,
          Name: data.fullName,
          RUT: data.personalId,
          Address: data.address,
          Department: data.department,
          Locality: data.locality,
        };
        break;
      default:
        dataNew = {};
        break;
    }
    return dataNew;
  }

  static async create(type, data) {
    const authenticated = true;
    const serializedData = BillingDataController.serializeBillingData(type, data);
    const response = await ApiHttpService.post(BILLING_DATA_PATH, serializedData, authenticated);
    const deSerializedData = BillingDataSerializer.deSerialize(response.data);
    return new BillingData(deSerializedData);
  }

  static async edit(id, type, data) {
    const authenticated = true;
    const serializedData = BillingDataController.serializeBillingData(type, data);
    serializedData.DFWId = id;
    const response = await ApiHttpService.post(BILLING_DATA_PATH, serializedData, authenticated);
    const deSerializedData = BillingDataSerializer.deSerialize(response.data);
    return new BillingData(deSerializedData);
  }

  static async delete(id) {
    const authenticated = true;
    const params = { idDatosFacturacion: id };
    const deleteBillingDataPath = `${BILLING_DATA_PATH}${ParamsHelper.createQueryParams(params)}`;
    const response = await ApiHttpService.delete(deleteBillingDataPath, {}, authenticated);
    return response;
  }

  static async createNewApi(type, data) {
    const authenticated = true;
    const serializedData = BillingDataController.serializeBillingDataNewApi(type, data);
    const response = await ApiHttpServiceNewApi.post(
      NEWAPI_BILLING_DATA_PATH, serializedData,
      authenticated,
    );
    const deSerializedData = BillingDataSerializer.deSerializNewApi(response.data.data);
    return new BillingData(deSerializedData);
  }

  static async editNewApi(id, type, data) {
    const authenticated = true;
    const serializedData = BillingDataController.serializeBillingDataNewApi(type, data);
    serializedData.id = id;
    const response = await ApiHttpServiceNewApi.put(
      NEWAPI_BILLING_DATA_PATH, serializedData,
      authenticated,
    );
    const deSerializedData = BillingDataSerializer.deSerializNewApi(response.data.data);
    return new BillingData(deSerializedData);
  }
}

export { BillingDataController };



// WEBPACK FOOTER //
// ./src/networking/controllers/BillingDataContoller.js